import { useMemo } from "react";
import useAuth from "@/hooks/useAuth";
import { NoPermissionScreen } from "@/components/screens/shared/NoPermissionScreen";

export default function IncidentDetailPage() {
  const { userRoles, displayNames } = useAuth();

  const hasIncidentsAccess = useMemo(() => {
    return userRoles?.some((r) => r.permissions?.incidents?.read === true) ?? false;
  }, [userRoles]);

  if (!hasIncidentsAccess) {
    return <NoPermissionScreen entityName={displayNames?.incidents?.plural || "Incidents"} />;
  }

  // TODO: Implement incident detail view
  return null;
}
